import React from 'react';
import { Container, Grid, useMediaQuery, Box } from '@mui/material';
import { useTheme } from '../context/ThemeContext';
import HeroHeader from '../components/HeroHeader';
import BeforeAfterSlider from '../components/BeforeAfterSlider';
import OurWorkBg from '../assets/images/header-backgrounds/background1.png';
import { Section } from '../components/styled/CommonStyles';

// Import all before/after images
import B1 from '../assets/images/before-after/B1.jpg';
import A1 from '../assets/images/before-after/A1.jpg';
import B2 from '../assets/images/before-after/B2.jpg';
import A2 from '../assets/images/before-after/A2.jpg';
import B3 from '../assets/images/before-after/B3.jpg';
import A3 from '../assets/images/before-after/A3.jpg';
import B4 from '../assets/images/before-after/B4.jpg';
import A4 from '../assets/images/before-after/A4.jpg';
import B5 from '../assets/images/before-after/B5.jpg';
import A5 from '../assets/images/before-after/A5.jpg';
import B6 from '../assets/images/before-after/B6.jpg';
import A6 from '../assets/images/before-after/A6.jpg';
import B7 from '../assets/images/before-after/B7.jpg';
import A7 from '../assets/images/before-after/A7.jpg';
import B8 from '../assets/images/before-after/B8.jpg';
import A8 from '../assets/images/before-after/A8.jpg';
import B9 from '../assets/images/before-after/B9.jpg';
import A9 from '../assets/images/before-after/A9.jpg';
import B10 from '../assets/images/before-after/B10.jpg';
import A10 from '../assets/images/before-after/A10.jpg';

function OurWorkPage() {
  const { currentTheme } = useTheme();
  const isMobile = useMediaQuery('(max-width:600px)');

  const beforeAfterPairs = [
    { before: B1, after: A1 },
    { before: B2, after: A2 },
    { before: B3, after: A3 },
    { before: B4, after: A4 },
    { before: B5, after: A5 },
    { before: B6, after: A6 },
    { before: B7, after: A7 },
    { before: B8, after: A8 },
    { before: B9, after: A9 },
    { before: B10, after: A10 },
  ];

  // Group pairs into rows of 2
  const rows = [];
  for (let i = 0; i < beforeAfterPairs.length; i += 2) {
    rows.push(beforeAfterPairs.slice(i, i + 2));
  }

  return (
    <>
      <HeroHeader 
        title="Gallery" 
        backgroundImage={OurWorkBg}
      />

      {rows.map((row, rowIndex) => (
        <Section 
          key={rowIndex} 
          theme={currentTheme}
          sx={{ 
            bgcolor: rowIndex % 2 === 1 ? 'background.default' : 'background.paper'
          }}
        >
          <Container>
            <Grid container spacing={isMobile ? 2 : 4}>
              {row.map((pair, index) => (
                <Grid item xs={12} md={6} key={index}>
                  <Box
                    sx={{
                      mb: isMobile ? 2 : 4,
                      borderRadius: 2,
                      overflow: 'hidden',
                      boxShadow: 3,
                      width: '100%',
                      position: 'relative',
                      height: isMobile ? 400 : 530,
                      '& > div': {
                        height: '100% !important',
                        width: '100% !important'
                      },
                      '& img': {
                        objectFit: 'contain',
                        width: '100%',
                        height: '100%'
                      }
                    }}
                  >
                    <BeforeAfterSlider 
                      beforeImage={pair.before}
                      afterImage={pair.after}
                      startPosition={50}
                    />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Section>
      ))}
    </>
  );
}

export default OurWorkPage;
   